import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
import { NotificationManager } from "react-notifications";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import CustomPopup from "../../Common/CustomPopup/CustomPopupComponent";
import MainService from "../../Common/MainService";
import {
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@material-ui/core";
import "./KYC.css";


export default function KYC(props) {
  const { user } = MainService.getLocalData();
    const { username } = user;
  const [isLoading, setIsLoading] = useState(true);

  const [kycPopup, setShowKycPopup] = useState(false);

  const [kycType, setKycType] = useState("");
  const [kycFile, setKycFile] = useState(null);

  const [kycAgreementDocumentLink, setKycAgreementDocumentLink] = useState("");

  const [viewKycDocumentPopup, setViewKycDocumentPopup] = useState(false);

  const [state, setState] = useState({
    columns: [
      { title: "Document type", field: "documenttype" }, //done by srini
      { title: "Document Status", field: "documentstatus" }, //done by srini
      {
        title: "Document Link",
        field: "documentlink", //done by srini
        render: () => (
          <Button variant="contained" onClick={() => viewKycDocumentsClick()}>
            View
          </Button>
        ),
      },
    ],
    data: [],
  });

  useEffect(() => {
    getKycDocument();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getKycDocument = () => {
    
    MainService.getKycDocument(username)
      .then((data) => {
        setIsLoading(false);
        if (data.length > 0) {
          setState({ ...state, data: data });
          setKycAgreementDocumentLink(data[0].documentlink); //done by srini
          // setKycAgreementDocumentLink(data[0].locationurl);
          setKycFile(null);
          setKycType("");
        }
      })
      .catch((e) => {
        setIsLoading(false);
        console.error(e);
        return NotificationManager.error(e);
      });
  };

  const viewKycDocumentsClick = () => {
    setViewKycDocumentPopup(!viewKycDocumentPopup);
  };
  const uploadKycClick = () => {
    setShowKycPopup(!kycPopup);
  };

  const uploadKycDataClick = () => {
    
    console.log("kycFile:",kycFile)
    if(kycFile !== null && kycType !== "")
    {
      var bodyFormData = new FormData();
    bodyFormData.append("file", kycFile);
    bodyFormData.append("mimetype", kycFile.type);

      MainService.uploadKyc(bodyFormData, username, kycType)
      .then((data) => {
        getKycDocument();
        setShowKycPopup(false);
        return NotificationManager.success("Kyc Uploaded");
      })
      .catch((e) => {
        setIsLoading(false);
        console.error(e);
        return NotificationManager.error("kyc not uploaded");
      });
    }else{
       return NotificationManager.error("Please choose the file and type ")
    }
    
  };

  /* kyc Details */
  const closeKycModal = (
    <span
      onClick={() => {
        setShowKycPopup(!kycPopup);
      }}
    >
      X
    </span>
  );
  const titleKyc = "Add KYC";
  const kycBody = (
    <div style={{ marginTop: "20px !important" }}>
      <div style={{ display: "inline !important" }}>
        <p>Upload KYC file:</p>
        <Button variant="contained" component="label">
          Upload File
          <input
            type="file"
            onChange={(e) => {
              setKycFile(e.target.files[0]);
            }}
            
          />
        </Button>
      </div>
      <FormControl fullWidth>
        <InputLabel id="kycLabel">KYC Type</InputLabel>
        <Select
          id="kycLabel"
          value={kycType}
          label="KYC"
          onChange={(e) => {
            setKycType(e.target.value);
          }}
          hidden
        >
          <MenuItem value="Pan">PAN</MenuItem>
          <MenuItem value="Aadhar">Aadhar</MenuItem>
          <MenuItem value="Passport">Passport</MenuItem>
        </Select>
      </FormControl>
      <Button
        style={{ marginRight: "10px" }}
        variant="contained"
        color="primary"
        className="registerBtn"
        type="button"
        onClick={() => uploadKycDataClick()}
      >
        Submit
      </Button>
      <FormControl
        fullWidth={true}
        className="forgotPwdLink"
        onClick={() => {
          setShowKycPopup(!kycPopup);
        }}
        style={{
          marginBottom: "20px",
          textAlign: "center",
          boxOrient: "0",
          display: "block",
          fontSize: "20",
        }}
      >
        Cancel
      </FormControl>
    </div>
  );

  /* View KYC Documents */
  const closeViewKycDocumentPopup = (
    <span
      onClick={() => {
        setViewKycDocumentPopup(!viewKycDocumentPopup);
      }}
    >
      X
    </span>
  );
  const titlecViewKycDocument = "View KYC Document";
  const viewKycDocumentBody = (
    <div style={{ marginTop: "20px !important" }}>
      <div style={{ display: "inline !important" }}>
        <embed
          className="viewWidthHeight"
          type="application/pdf"
          src={kycAgreementDocumentLink}
        ></embed>
      </div>

      <FormControl
        fullWidth={true}
        className="forgotPwdLink"
        onClick={() => {
          setViewKycDocumentPopup(!viewKycDocumentPopup);
        }}
        style={{
          marginBottom: "20px",
          textAlign: "center",
          boxOrient: "0",
          display: "block",
          fontSize: "20",
        }}
      >
        Cancel
      </FormControl>
    </div>
  );
  return (
    <Grid container spacing={1}>
      <Grid item md={12} sm={12} xs={12} className="buttonsContainer">
        <Button
          style={{ float: "right" }}
          variant="contained"
          color="primary"
          className="registerBtn"
          type="button"
          onClick={() => uploadKycClick()}
        >
          Upload KYC
        </Button>
      </Grid>

      <Grid item md={12} sm={12} xs={12}>
        {isLoading ? (
         <div className="cardStyleForDashboardItems"> <CircularProgress /></div>
        ) : (
          <div>
            {state.data.length > 0 ? (
              <div>
                <h3>KYC Status : Verified</h3>
                <MaterialTable
                  fullWidth={12}
                  title={`Investor KYC Documents`}
                  columns={state.columns}
                  data={state.data}
                  editable={{}}
                  
                >
                  <CircularProgress className="loginLoader" />
                  </MaterialTable>
              </div>
            ) : (
              <div>
                <h3>KYC Status :Not Verified</h3>
                <h3>Do your KYC...</h3>
              </div>
            )}
          </div>
        )}
      </Grid>

      <CustomPopup
        closeButton={closeKycModal}
        isOpen={kycPopup}
        closeModal={kycPopup}
        content={kycBody}
        title={titleKyc}
      />

      <CustomPopup
        closeButton={closeViewKycDocumentPopup}
        isOpen={viewKycDocumentPopup}
        closeModal={viewKycDocumentPopup}
        content={viewKycDocumentBody}
        title={titlecViewKycDocument}
      />
    </Grid>
  );
}
